{
  "internal_id": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true
    }
  },
  "year": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true
    }
  },
  "quarter": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "isNotRenderable": true
    }
  },
  "year_and_quarter": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Year + Quarter",
      "width": 100
    }
  },
  "company_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "isNotRenderable": true
    }
  },
  "oil_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Oil"
    }
  },
  "natural_gas_mmcf_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mmcf/d"
    },
    "ui": {
      "label": "Natural Gas"
    }
  },
  "condensate_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Condensate"
    }
  },
  "ngl_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "NGL"
    }
  },
  "liquid_productions_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Liquid Productions"
    }
  },
  "oil_equivalent_boe_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Production"
    }
  },
  "ngl_and_condensate_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "NGL & CND"
    }
  },
  "g_and_a": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "G&A"
    }
  },
  "operating_expense_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Operating Expense"
    }
  },
  "netback_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Netback"
    }
  },
  "transportation_costs_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Transportation Costs"
    }
  },
  "royalty_cost_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Royalty Cost"
    }
  },
  "hedging_gain_loss_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Hedging Gain/Loss"
    }
  },
  "positive_capital_expenditure": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Capital Expenditure"
    }
  },
  "market_capitalization": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Market Capitalization"
    }
  },
  "net_debt": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Net Debt"
    }
  },
  "net_debt_over_ltmocf": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Net Debt / LTMOCF"
    }
  },
  "ev_over_ltmocf": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "x",
      "displaySymbol": true,
      "fractionDigits": 1
    },
    "ui": {
      "label": "EV/LTMOCF"
    }
  },
  "enterprise_value_ev": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 0
    },
    "ui": {
      "label": "Enterprise Value"
    }
  },
  "cash_from_operations": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Cash from Operations"
    }
  },
  "capex": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Capex"
    }
  },
  "oil_realized_price_cad_per_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/bbl"
    },
    "ui": {
      "label": "Oil Realized Price"
    }
  },
  "natural_gas_realized_price_cad_per_mcf": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/mcf"
    },
    "ui": {
      "label": "Natural Gas Realized Price"
    }
  },
  "condensate_realized_price_cad_per_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/bbl"
    },
    "ui": {
      "label": "Condensate Realized Price"
    }
  },
  "ngl_realized_price_cad_per_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/bbl"
    },
    "ui": {
      "label": "NGL Realized Price"
    }
  },
  "oil_equivalent_realized_price_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "Oil Equivalent Realized Price"
    }
  },
  "shares": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Shares Outstanding"
    }
  },
  "dividends_paid_mcad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "MCAD"
    },
    "ui": {
      "label": "Dividends Paid"
    }
  },
  "decommissioning_obligations_mcad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "MCAD"
    },
    "ui": {
      "label": "Decommissioning Obligations"
    }
  },
  "share_buybacks_mcad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "MCAD"
    },
    "ui": {
      "label": "Share Buybacks"
    }
  },
  "d_and_d_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "D&D"
    }
  },
  "financing_costs_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Financing Costs"
    }
  },
  "share_based_compensation_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Share Based Compensation"
    }
  },
  "net_debt_mda_cad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "CAD"
    },
    "ui": {
      "label": "Net Debt MDA"
    }
  },
  "net_debt_formula_cad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "CAD"
    },
    "ui": {
      "label": "Net Debt Formula"
    }
  },
  "net_debt_over_cash_from_operations": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "%",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Net Debt / Cash from Operations"
    }
  },
  "percent_of_production_as_liquids": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "%"
    },
    "ui": {
      "label": "Percent of Production as Liquids"
    }
  },
  "enterprise_value_per_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe/d"
    },
    "ui": {
      "label": "EV/BOE/d"
    }
  }
}
